/**
 * Types de prestation — libellés clairs et filtrage selon les services activés sur la boutique.
 */

/** @typedef {'CRENEAUX' | 'RENDEZ_VOUS' | 'RESERVATION'} PrestationTypeId */

/** @type {Array<{ id: PrestationTypeId, label: string, shortLabel: string, icon: string, description: string, hint: string, serviceKeys: string[], recommendedWhen?: (c: object) => boolean }>} */
export const PRESTATION_TYPES = [
  {
    id: 'CRENEAUX',
    label: 'Créneaux & terrains',
    shortLabel: 'Créneaux',
    icon: '⏱️',
    description: 'Réservation à horaire fixe sur un terrain, une salle ou un créneau.',
    hint: 'Padel, foot, tennis, karting, location de salle…',
    serviceKeys: ['priseCreneaux', 'moduleCreneaux'],
    recommendedWhen: (c) => Boolean(c?.moduleCreneaux || c?.priseCreneaux),
  },
  {
    id: 'RENDEZ_VOUS',
    label: 'Rendez-vous',
    shortLabel: 'RDV',
    icon: '📅',
    description: 'Rendez-vous avec un praticien ou un conseiller, durée classique.',
    hint: 'Coiffure, soin, cours particulier, consultation…',
    serviceKeys: ['priseRDV'],
    recommendedWhen: (c) => Boolean(c?.priseRDV) && !c?.moduleCreneaux,
  },
  {
    id: 'RESERVATION',
    label: 'Réservation de table',
    shortLabel: 'Table',
    icon: '🍽️',
    description: 'Réservation de table au restaurant ou en salle.',
    hint: 'Restaurant, brasserie, événement sur place…',
    serviceKeys: ['reservationTable'],
    recommendedWhen: (c) => Boolean(c?.reservationTable),
  },
];

const hasAnyService = (commercant, keys) =>
  keys.some((key) => Boolean(commercant?.[key]));

/** Types proposés selon les modules activés sur le commerçant */
export function getAvailablePrestationTypes(commercant) {
  const matched = PRESTATION_TYPES.filter((t) => hasAnyService(commercant, t.serviceKeys));
  return matched.length > 0 ? matched : PRESTATION_TYPES;
}

export function getPrestationTypeMeta(typeId) {
  return PRESTATION_TYPES.find((t) => t.id === typeId) || null;
}

export function getPrestationTypeLabel(typeId) {
  return getPrestationTypeMeta(typeId)?.label || typeId || '—';
}

/** Type par défaut à la création d'une prestation */
export function getDefaultPrestationType(commercant) {
  const available = getAvailablePrestationTypes(commercant);
  if (available.length === 1) return available[0].id;
  const recommended = available.find((t) => t.recommendedWhen?.(commercant));
  if (recommended) return recommended.id;
  return available[0]?.id || 'CRENEAUX';
}
